import React, { useState, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/icones/iconsmind/style.css';
import { Link } from 'react-router-dom'
import moment from 'moment';
import { get } from '../util/AcessoApi'
import { getUsuario } from '../util/Configuracoes'
import { ACOES } from '../util/Enums'



const AcessoRapido = (props) => {
    console.log('props.permissoes: ', props.permissoes);
    return (<div className='col-lg-4 col-md-6'>
        <div className='row'>
            {props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 6).permissoes.find(x => parseInt(x) === ACOES.CONSULTAR) && <div className='mb-4 col-lg-4 col-md-6 col-sm-6'>
                <Link to={{ pathname: '/estoque/produto/cadastro' }} style={{ textDecoration: 'none' }}>
                    <div className='dashboard-small-card card b-radius-10'>
                        <a class="a-acesso-rapido" data-flag="administrativo" href="/dashboard">
                            <div class="text-center card-body flex-vertical card-acesso">
                                <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                    <i class="icon-Box-Open" style={{ fontSize: '40px' }}></i>
                                </div>
                                <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                    <p class="card-text font-weight-semibold mb-0">Produto</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </Link>
            </div>}
            {props.permissoes && props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 9).permissoes.find(x => parseInt(x) === ACOES.CONSULTAR) && <div className='mb-4 col-lg-4 col-md-6 col-sm-6'>
                <Link to={{ pathname: '/estoque/produtoentrada/cadastro' }} style={{ textDecoration: 'none' }}>
                    <div className='dashboard-small-card card b-radius-10'>
                        <a class="a-acesso-rapido" data-flag="administrativo" href="/dashboard">
                            <div class="text-center card-body flex-vertical card-acesso">
                                <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                    <i class="icon-Add-Cart" style={{ fontSize: '40px' }}></i>
                                </div>
                                <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                    <p class="card-text font-weight-semibold mb-0">Entrada de Produto</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </Link>
            </div>}
            {props.permissoes && props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 10).permissoes.find(x => parseInt(x) === ACOES.CONSULTAR) && <div className='mb-4 col-lg-4 col-md-6 col-sm-6'>
                <Link to={{ pathname: '/estoque/produtosaida/cadastro' }} style={{ textDecoration: 'none' }}>
                    <div className='dashboard-small-card card b-radius-10'>
                        <a class="a-acesso-rapido" data-flag="administrativo" href="/dashboard">
                            <div class="text-center card-body flex-vertical card-acesso">
                                <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                    <i class="icon-Remove-Cart" style={{ fontSize: '40px' }}></i>
                                </div>
                                <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                    <p class="card-text font-weight-semibold mb-0">Saída de Produto</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </Link>
            </div>}
        </div>
    </div>)
}

const AuditoriaAgenda = (props) => {
    const [data, setData] = useState([])

    useEffect(() => {
        if (props.permissoes && props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 42).permissoes.find(x => parseInt(x) === ACOES.CONSULTAR)) {
            Promise.resolve(get(`/controleAcesso/auditoriaDashboard`)).then(obj => setData(obj))
        }
    }, [props.permissoes])

    return (props.permissoes && props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 42).permissoes.find(x => parseInt(x) === ACOES.CONSULTAR) ?
        <div className={'col-lg-5 col-md-6'}>
            <div className='card b-radius-10'>
                <div className='card-body'>
                    <div className='mb-2 row-space-between'>
                        <div class="card-title">Auditoria Agenda</div>
                    </div>
                    <div className='dashboard-auditoria'>
                        <div className='scrollbar-container custom-scrollbar'>
                            <table className="table table-sm table-borderless">
                                <thead>
                                    <th>Usuário</th>
                                    <th>Módulo</th>
                                    <th>Ação</th>
                                    <th>Data</th>
                                </thead>
                                <tbody style={{ fontSize: 12 }}>
                                    {data && data.map(x =>
                                        <tr>
                                            <td><span class="font-weight-medium">{x.nome}</span></td>
                                            <td><span class="font-weight-medium">{x.modulo}</span></td>
                                            <td><span class="font-weight-medium">{x.acao}</span></td>
                                            <td class="text-right"><span class="text-muted">{x.data}</span></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div> : <></>)
}

const ProximosAgendamentos = (props) => {
    const [data, setData] = useState([])
    const user = getUsuario()


    useEffect(() => {
        Promise.resolve(get(`/administracao/agendasDashboard`, { data: moment().format('DD/MM/YYYY'), usuario: user })).then(obj => {
            setData(obj)
        })
    }, [])


    return (
        <div className='card b-radius-10 mb-4 col-lg-3 col-md-6'>
            <div className='card-body'>
                <div className='mb-2 row-space-between'>
                    <div className="card-title">Próximos Agendamentos</div>
                </div>
                <div className='dashboard-agendamento'>
                    <div className='scrollbar-container custom-scrollbar'>
                        {data && data.map(x => {
                            return (
                                <div class="display-flex flex-row mb-3 pb-3 border-bottom">
                                    <i className={x.icone} style={{ fontSize: '27px' }}></i>
                                    <div className="pl-3 pr-2">
                                        <p className="font-weight-medium mb-0 ">{x.socio}</p>
                                        <p className="text-muted mb-0 text-small">{x.data_inicial && (moment(x.data_inicial, 'DD/MM/YYYY').format('ddd') + ' às ' + x.horario_inicial) + (x.data_final ? ' - ' + moment(x.data_final, 'DD/MM/YYYY').format('ddd') + ' às ' + x.horario_final : '')}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>)
}

export { AcessoRapido, AuditoriaAgenda, ProximosAgendamentos }